var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 39,
    viewBox: "0 0 56 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4101 0.0717773C2.4612 0.0717773 0.0947266 2.5728 0.0947266 5.5776V33.4004C0.0947266 36.4052 2.46108 38.9273 5.4101 38.9273H50.5898C53.5387 38.9273 55.9051 36.4052 55.9051 33.4004V5.5776C55.9051 2.5728 53.5393 0.0717773 50.5898 0.0717773H5.4101ZM5.4101 2.75129H50.5898C50.9795 2.75129 51.3568 2.84709 51.69 3.00271L29.723 23.4981C28.7081 24.4448 27.3557 24.4448 26.339 23.4981L4.33048 3.00271C4.65953 2.85224 5.02706 2.75129 5.41034 2.75129H5.4101ZM2.79388 5.22145L18.3873 19.7508L3.08456 34.7622C2.88249 34.3598 2.75226 33.9042 2.75226 33.4014V5.57856C2.75226 5.45566 2.78099 5.34069 2.79397 5.22246L2.79388 5.22145ZM53.2057 5.24202C53.2178 5.35324 53.247 5.46118 53.247 5.57708V33.3999C53.247 33.892 53.1297 34.3434 52.9355 34.7396L37.6755 19.7282L53.2061 5.24079L53.2057 5.24202ZM35.7437 21.5299L50.6715 36.247H50.5885H5.40889C5.38757 36.247 5.36764 36.2475 5.34632 36.247L20.337 21.5502L24.5313 25.4654C26.5028 27.3015 29.5569 27.3043 31.5286 25.4654L35.7437 21.5299Z",
    fill: "url(#paint0_linear_506_274)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_506_274",
    x1: -3.5,
    y1: 1,
    x2: 68,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7933FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB4076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7ab40962c6f2b28322ab509b44f3a3f3.svg";
export { ForwardRef as ReactComponent };